import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../../pay-icon/icon.component';
import { IconNames } from '../../../pay-icon/IconNames';

@Component({
  selector: 'pay-login-password-reset-requirement',
  imports: [IconComponent, TranslateModule, NgClass],
  templateUrl: './password-reset-requirement.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordResetRequirementComponent {
  readonly requirementText = input.required<string>();
  readonly isCorrect = input.required<boolean>();

  protected readonly IconNames = IconNames;
}
